export const magdaBazan = {
    'meta': {
        'title': 'Lekarz rezydent psychiatrii Magda Bazan • Centrum COLLIGO',
        'description': 'Jestem lekarzem w trakcie specjalizacji z psychiatrii. Doświadczenie zawodowe zdobywałam w Szpitalu Zespolonym w Toruniu oraz Poradniach Zdrowia Psychicznego.'
    },
    'url': {
        'address': '/torun/zespol/psychiatra-magda-bazan/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/magda-bazan.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psychiatra w Toruniu Magda Bazan'
        }
    }
}